/* eslint-disable no-undef */
import axios from 'axios';

export const handleUploadFile = async (file, userInfo, setFiles, setErrorUploads) => {
  const bodyFormData = new FormData();
  for (let i = 0; i < file.length; i++) {
    const element = file[i];
    bodyFormData.append('files', element);
  }
  try {
    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/uploads/add`, bodyFormData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${userInfo.token}`,
      },
    });
    localStorage.setItem('localFiles', JSON.stringify(data));
    setFiles(data);
  } catch (error) {
    setErrorUploads(true);
  }
};
